<template>
  <div class="timePickerComponent RentComponent position-relative" v-on:click="toggleModal(true)" v-bind="$attrs">
    <template v-if="!isValid">
      <MessageComponent :message-class="'error-time-message'" :message="message"></MessageComponent>
    </template>
    <div id="triangle"></div>
    <div id="triangleBorder"></div>
    <div class="timePickerComponentContent RentComponent">
      <h5 :class="{'error-message-color': !isValid}">{{$t('time')}}</h5>
      <p id="timeParagraph">
      {{ fullTime.split(':')[0] }} : {{ fullTime.split(':')[1] }}
      </p>
    </div>
    <div v-if="timePickerModal">
      <transition name="timePickerModal">
        <div class="modal-mask">
          <div class="modal-wrapper" >
            <div class="modal-content">
              <div class="modal-header" id="timePickerModalHeader">
                <button type="button"
                        class="close"
                        v-on:click.stop="closeModal(false)">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="timePickerModalText">
                  <h5>{{$t('time')}}</h5>
                  <p>{{modalTranslation}}</p>
                </div>
                <div class="timePickerModalInput">
                  <select :value="currentHours.length === 1 ? '0' + currentHours : currentHours" @change="changeHours">
                    <option v-for="(hour) in hours" :value="hour" :key="hour">
                      {{ hour }}
                    </option>
                  </select>
                  <span>:</span>
                    <select :value="currentMinutes.length === 1 ? '0' + currentMinutes : currentMinutes" @change="changeMinutes">
                    <option v-for="(minute) in minutes" :value="minute" :key="minute">
                      {{ minute }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
  <div v-if="timePickerModal" id="closeTimepickerModal" v-on:click="closeModal(false)"></div>

</template>

<script lang="ts">
import {defineComponent} from 'vue';
import './TimePicker.scss';
// @ts-ignore
import MessageComponent from "../message/MessageComponent.vue";

export default defineComponent({
  name: 'TimePickerComponent',
  components: { MessageComponent },
  emits: ['getTime'],
  props: {
    modalTranslation: {
      type: String,
      required: false,
    },
    pickupTime: {
      type: Boolean,
      required: false,
    },
    timeStore: {
      type: String
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    message: {
      type: String
    }
  },

  mounted() {
    let template = document.getElementById('timePickerComponent');
    if (template){
      template.classList.add('RentComponent');
    }
  },

  data() {
    return {
      currentHours: '10',
      currentMinutes: '00',
      hours: <string[]>[],
      minutes: <string[]>[],
      timePickerModal: false,
      currentTime: '',
      fullTime: <string|null>null
    }
  },

  watch: {
    timeStore(newTime, oldTime) {
      this.handleTimeStore(newTime);
    },
  },

  created() {
    this.hours = generateTimeOptionsList(24);
    this.minutes = generateTimeOptionsList(60);

    this.handleTimeStore(this.timeStore);
    this.generateTime();
    this.triggerTimeChange(this.fullTime);

    function generateTimeOptionsList(size) {
      const arr: string[] = [];

      for (let i = 0; i < size; i++){
        const str: string = i.toString();
        arr.push(str.length < 2 ? '0' + str : str);
      }
      return arr;
    }
  },
  methods: {
    toggleModal: function (value) {
      this.handleModal(value);
    },
    closeModal: function (value) {
      this.handleModal(value);
    },
    handleModal: function (value) {
      this.timePickerModal = value;
    },
    changeHours(e) {
      this.currentHours = e.target.value;

      this.generateTime();
      this.triggerTimeChange(this.fullTime);
    },
    changeMinutes(e) {
      this.currentMinutes = e.target.value;

      this.generateTime();
      this.triggerTimeChange(this.fullTime);
    },
    handleTimeStore(time): void {
      if (this.timeStore) {
        this.currentHours = time.split(':')[0].toString();
        this.currentMinutes = time.split(':')[1].toString();
      }
      this.generateTime();
    },
    generateTime(): void {
      this.fullTime = `${this.currentHours.length < 2 ? '0'+this.currentHours : this.currentHours}:${this.currentMinutes.length < 2 ? '0'+this.currentMinutes : this.currentMinutes}`;
    },
    triggerTimeChange(value) {
      this.$emit('getTime', {value, pickup: this.pickupTime});
    },
  },
});


</script>